import React, { Component } from 'react';

class Rainbow extends Component {
	onWheel = (e) => { e.preventDefault(); }
	render() { return <div className="Rainbow" onWheel={this.onWheel}></div> }
}

export default Rainbow;


// WEBPACK FOOTER //
// ./src/components/common/Rainbow.jsx